module.exports = __webpack_public_path__ + "static/media/logo192.a5565d75.png";